<template>
    <div class="hidden md:grid gap-4" :class="stepperClasses()">
        <div class="flex flex-col items-center text-center relative" v-for="(step, index) in steps" :key="index">
            <div :class="lineClasses(index)"></div>
            <div class="rounded-full py-1 w-12 h-12 py-3 text-white text-base font-bold mb-4 z-10"
                 :class="stepNumberClasses(index)">
                {{index + 1}}
            </div>
            <p class="text-sm" style="white-space: pre-line">{{step}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            steps: {
                type: Array,
                required: true
            },
            current: {
                type: Number,
                required: true
            }
        },
        methods: {
            stepperClasses() {
                let grid = `grid-cols-${this.steps.length}`;
                return `${grid}`;
            },
            isActive(index) {
                return this.current >= index + 1;
            },
            lineClasses(index) {
                let line = 'line-both';
                if (index === 0) {
                    line = 'line-right';
                } else if (this.steps.length - 1 === index) {
                    line = 'line-left';
                }
                let background = 'bg-gray-400';
                if (this.isActive(index)) {
                    background = 'bg-primary-500';
                }
                return `${line} ${background}`;
            },
            stepNumberClasses(index) {
                return this.isActive(index) ? 'bg-primary-500' : 'bg-gray-400';
            }
        }
    }
</script>

<style scoped>
    .line-right, .line-both, .line-left {
        content: " ";
        position: absolute;
        top: 23px;
        height: 4px;
        width: auto;
    }

    .line-right {
        left: 50%;
        right: -1rem;
    }

    .line-both {
        left: 0;
        right: -1rem;
    }

    .line-left {
        left: 0;
        right: 50%;
    }
</style>
